import React from 'react';
import { Check, LockKeyhole, List, X } from 'lucide-react';

export const FusedChapterNav = ({ lesson, state, open, onToggle, onView, busy }) => <aside className="fp-chapter-nav" data-testid="fused-chapter-nav">
  <button className="fp-chapter-toggle" data-testid="fused-chapters-toggle" onClick={onToggle} aria-expanded={open}>
    <List size={18} /><span>Contenido de la clase</span>{open ? <X size={18} /> : <span>{state.step?.page || lesson.page_count}/{lesson.page_count}</span>}
  </button>
  <div className={`fp-chapter-list ${open ? 'fp-chapters-open' : ''}`}>
    <p className="fp-eyebrow fp-nav-title" data-testid="fused-chapters-title">RECORRIDO CLÍNICO</p>
    {lesson.chapters.map(chapter => {
      const locked = chapter.start_index > state.current_index;
      const completed = state.current_index > (chapter.end_index ?? chapter.start_index + chapter.question_ids.length);
      const active = state.step?.page === chapter.page;
      return <button key={chapter.page} type="button" className={`fp-chapter ${active ? 'fp-chapter-active' : ''}`} data-testid={`fused-chapter-${chapter.page}`}
        onClick={() => onView(chapter.start_index)} disabled={locked || busy} aria-current={active ? 'step' : undefined}>
        <span className="fp-chapter-number">{completed ? <Check size={15} /> : String(chapter.page).padStart(2, '0')}</span>
        <span className="fp-chapter-text">{chapter.title}<small>{chapter.question_ids.length} preguntas</small></span>
        {locked && <LockKeyhole size={12} className="fp-chapter-lock" />}
      </button>;
    })}
  </div>
</aside>;